import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Hero3 from "../components/Hero3/Hero3";
import ContactUsSection1 from "../components/Contact/ContactUsSection1/ContactUsSection1";

import HeroImg from "../assets/contactushero.png";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="ContactUs" />
      <Navbar />
      <Hero3
        heading={t("pages.contact.heading")}
        heading2={t("pages.contact.heading2")}
        paragraph={t("pages.contact.paragraph")}
        imageSrc={HeroImg}
      />
      <div style={{ backgroundColor: "#FFF5EC" }}>
        <ContactUsSection1 />
      </div>
      <Footer />
    </>
  );
};

export default Contact;
